import React, { useEffect, useState } from 'react';
import ThemeToggle from '../components/ThemeToggle';

const episodes = [
  {
    id: 1,
    number: 'EPISÓDIO 1',
    title: 'O Peso do Amanhã',
    description: 'Quando a ansiedade faz você sofrer por situações que ainda nem aconteceram.',
    duration: '6 min',
    url: encodeURI('/audio/podCash_01.mp3'),
  },
  {
    id: 2,
    number: 'EPISÓDIO 2',
    title: 'A Reunião que Nem Aconteceu',
    description: 'Como nossa mente cria cenários que quase nunca se tornam realidade.',
    duration: '7 min',
    url: encodeURI('/audio/podCash_02.mp3'),
  },
  {
    id: 3,
    number: 'EPISÓDIO 3',
    title: 'Quando a Respiração Esquece de Respirar',
    description: 'Entenda por que o corpo reage primeiro e como recuperar o controle.',
    duration: '5 min',
    url: encodeURI('/audio/podCash_03.mp3'),
  },
  {
    id: 4,
    number: 'EPISÓDIO 4',
    title: 'O Peso de Querer Controlar Tudo',
    description: 'Nem tudo depende de você. Descubra como abandonar o peso de tentar controlar aquilo que está fora das suas mãos.',
    duration: '6 min',
    url: encodeURI('/audio/podCash_04.mp3'),
  },
  {
    id: 5,
    number: 'EPISÓDIO 5',
    title: 'Quando a Noite Chega, Mas a Mente Não Dorme',
    description: 'Por que os pensamentos aceleram na hora de dormir e como criar um ritual mais tranquilo para descansar.',
    duration: '6 min',
    url: encodeURI('/audio/podCash_05.mp3'),
  },
];

const PodcashAnxiety = () => {
  const [isDark, setIsDark] = useState(false);
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsDark(document.body.classList.contains('dark-mode'));
    const observer = new MutationObserver(() => {
      setIsDark(document.body.classList.contains('dark-mode'));
    });
    observer.observe(document.body, { attributes: true });

    // Alguns WebViews do app mobile (EbookViewer) medem a altura do documento
    // antes de desenhar a barra de navegação própria sobreposta, cortando o
    // scroll no final da página. Forçamos html/body a cederem o scroll para
    // este container em vez de depender do scroll do documento.
    const html = document.documentElement;
    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = document.body.style.overflow;
    html.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    return () => {
      observer.disconnect();
      html.style.overflow = prevHtmlOverflow;
      document.body.style.overflow = prevBodyOverflow;
    };
  }, []);

  const bg = isDark ? '#0f0f1a' : '#f5f7fa';
  const surface = isDark ? '#1a1a2e' : '#ffffff';
  const textPrimary = isDark ? '#e8e8f0' : '#1f2937';
  const textMuted = isDark ? '#8888aa' : '#6b7280';
  const border = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.08)';
  const heroBg = isDark
    ? 'linear-gradient(135deg,#1a1440 0%,#0d1b3e 50%,#1a0d2e 100%)'
    : 'linear-gradient(135deg,#ede9fe 0%,#dbeafe 50%,#f3e8ff 100%)';
  const heroBorder = isDark ? 'rgba(124,106,247,0.25)' : 'rgba(124,106,247,0.2)';
  const badgeBg = isDark ? 'rgba(124,106,247,0.2)' : 'rgba(124,106,247,0.1)';
  const badgeBorder = isDark ? 'rgba(124,106,247,0.5)' : 'rgba(124,106,247,0.4)';
  const badgeColor = isDark ? '#a98df5' : '#6d4af7';
  const numberColor = isDark ? '#a98df5' : '#6d4af7';
  const pendingBg = isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)';
  const pendingColor = isDark ? '#6b6b8a' : '#9ca3af';
  const playBg = isDark ? 'rgba(124,106,247,0.18)' : 'rgba(124,106,247,0.12)';
  const playColor = isDark ? '#a98df5' : '#6d4af7';
  const tipBg = isDark ? 'rgba(243,193,55,0.07)' : 'rgba(243,193,55,0.1)';
  const tipBorder = isDark ? 'rgba(243,193,55,0.2)' : 'rgba(243,193,55,0.3)';
  const tipColor = isDark ? 'rgba(243,193,55,0.85)' : '#92660a';

  return (
    <div style={{
      background: bg, height: '100vh', color: textPrimary,
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      overflowY: 'auto', WebkitOverflowScrolling: 'touch',
    }}>
      <ThemeToggle />

      {/* Header */}
      <div style={{ padding: '64px 20px 12px', display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{
          width: 40, height: 40, flexShrink: 0, borderRadius: 12, display: 'flex',
          alignItems: 'center', justifyContent: 'center', fontSize: 20,
          background: 'linear-gradient(135deg,#7c6af7,#a855f7)',
        }}>🎙️</div>
        <div>
          <div style={{ fontSize: 18, fontWeight: 700, letterSpacing: 0.5 }}>Conversas da Clara</div>
          <div style={{ fontSize: 12, color: textMuted, marginTop: 1 }}>Um projeto de áudio da Clara · DropsDay</div>
        </div>
      </div>

      {/* Hero */}
      <div style={{
        margin: '0 16px 24px', padding: '22px 20px',
        background: heroBg, borderRadius: 16,
        border: `1px solid ${heroBorder}`, position: 'relative', overflow: 'hidden',
      }}>
        <div style={{
          display: 'inline-block', background: badgeBg, border: `1px solid ${badgeBorder}`,
          color: badgeColor, fontSize: 10, fontWeight: 700, letterSpacing: 1.5,
          textTransform: 'uppercase', padding: '4px 10px', borderRadius: 20, marginBottom: 10,
        }}>✦ Série em áudio</div>
        <p style={{ fontSize: 14, color: textMuted, lineHeight: 1.6, margin: 0 }}>
          Histórias e reflexões criadas para ajudar você a cuidar da mente, um episódio de cada vez.
        </p>
      </div>

      {/* Section label */}
      <p style={{ fontSize: 13, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', color: textMuted, margin: '0 20px 12px' }}>
        Episódios
      </p>

      {/* Episode cards */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: '0 16px', marginBottom: 28 }}>
        {episodes.map((ep) => (
          <div
            key={ep.id}
            style={{
              background: surface, borderRadius: 16,
              border: `1px solid ${border}`, padding: '16px',
            }}
          >
            <div style={{
              fontSize: 11, fontWeight: 700, letterSpacing: 1,
              color: numberColor, marginBottom: 6,
            }}>
              🌙 {ep.number}
            </div>
            <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6 }}>
              {ep.title}
            </div>
            <div style={{ fontSize: 13, color: textMuted, lineHeight: 1.6, marginBottom: 10 }}>
              {ep.description}
            </div>
            <div style={{ fontSize: 12, color: textMuted, marginBottom: expandedId === ep.id ? 12 : 0 }}>
              ⏱ {ep.duration}
            </div>

            {expandedId === ep.id ? (
              <>
                <audio controls autoPlay preload="none" src={ep.url} style={{ width: '100%', display: 'block', marginBottom: 10 }}>
                  Seu navegador não suporta áudio HTML5.
                </audio>
                <button
                  onClick={() => setExpandedId(null)}
                  style={{
                    background: 'none', border: 'none', cursor: 'pointer',
                    fontSize: 12, fontWeight: 600, color: textMuted, padding: 0,
                  }}
                >
                  ▲ Recolher
                </button>
              </>
            ) : ep.url ? (
              <button
                onClick={() => setExpandedId(ep.id)}
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: 6,
                  fontSize: 13, fontWeight: 700, color: playColor,
                  background: playBg, padding: '8px 16px', borderRadius: 20,
                  border: 'none', cursor: 'pointer', marginTop: 12,
                }}
              >
                ▶ Ouvir
              </button>
            ) : (
              <div style={{
                display: 'inline-flex', alignItems: 'center', gap: 6,
                fontSize: 12, fontWeight: 600, color: pendingColor,
                background: pendingBg, padding: '6px 12px', borderRadius: 20,
                marginTop: 12,
              }}>
                🔒 Em breve
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Tip box */}
      <div style={{
        margin: '0 16px 28px', padding: 16,
        background: tipBg, border: `1px solid ${tipBorder}`,
        borderRadius: 16, display: 'flex', gap: 12, alignItems: 'flex-start',
      }}>
        <span style={{ fontSize: 20, flexShrink: 0, marginTop: 2 }}>💡</span>
        <div style={{ fontSize: 13, color: tipColor, lineHeight: 1.6 }}>
          <strong style={{ display: 'block', marginBottom: 3 }}>Dica Drops</strong>
          Ouvir os episódios da Clara antes de dormir pode ajudar a identificar padrões emocionais.
          Combine com a meditação guiada do app para melhores resultados.
        </div>
      </div>

      {/* Safe area — margem extra para não ficar escondido sob a barra de navegação do EbookViewer no app */}
      <div style={{ height: 90 }} />
    </div>
  );
};

export default PodcashAnxiety;
